import { RowAdminAppServicesDto } from "@/dtos";
import { ActionAdministrator, Actions, AdministratorApplicationService } from "@/entities";
import { ActionTypes } from "@/helpers/types";

export const formatRowAdministratorApplicationService = (adminAppService: AdministratorApplicationService, actions: Actions[])
    : RowAdminAppServicesDto => {
    const adminActions: ActionAdministrator[] = [];
    for (const action of actions) {
        const adminAction = adminAppService.actions.find((x) => x.action_id == action.id);
        if (adminAction) {
            adminAction.is_disable = (adminAction.type == ActionTypes.READ) ? true : false;
            adminActions.push(adminAction);
            continue;
        }

        const newAdminAction: ActionAdministrator = {
            action_id: action.id,
            name: action.name,
            type: action.type,
            is_active: false,
            is_disable: (action.type == ActionTypes.READ) ? true : false
        }        

        adminActions.push(newAdminAction);
    }

    const row: RowAdminAppServicesDto = {
        id: adminAppService.id,
        menu: adminAppService.service.menu.name,
        service: adminAppService.service.name,
        id_service: adminAppService.service.id,
        items: adminActions,
        is_active: adminAppService.is_active
    }

    return row;
}
